import { render, staticRenderFns } from "./WorkshopsCycle2.vue?vue&type=template&id=dc80e944&scoped=true&"
import script from "./WorkshopsCycle2.vue?vue&type=script&lang=js&"
export * from "./WorkshopsCycle2.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopsCycle2.vue?vue&type=style&index=0&id=dc80e944&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc80e944",
  null
  
)

export default component.exports